// extracted by mini-css-extract-plugin
module.exports = {"w1kw2wmc":"w1kw2wmc"};